<template>
  <ConfirmationPopup
    ref="confirmationPopup"
    type="error"
    :closeable="true"
    :title="popupTitle"
    message=""
    :controls="controls"
    :max-width="500"
    @close="onClose"
    @edit-data="onEditData"
    @search-offers="onSearchOffers"
  >
    <div class="response-status__content" v-if="responseMessage">
      <p>Відповідь від модуля страхової компанії: {{ responseMessage }}</p>
    </div>
  </ConfirmationPopup>
</template>

<script>
import { ConfirmationPopup } from '@/shared/ui/popup';

export default {
  name: 'ResponseStatusPopup',
  components: { ConfirmationPopup },
  data() {
    return {
      popupTitle: 'Увага! При спробі заявити/підписати поліс виникла помилка',
      responseMessage: null,
      isConfirmMode: false,
      errorInfo: null,
    };
  },
  computed: {
    isBlackListError() {
      return this.errorInfo?.errorType === 'black-list';
    },
    controls() {
      if (this.isConfirmMode) {
        return [{ type: 'default', label: 'Редагувати дані', event: 'edit-data' }];
      }

      const buttons = [];
      buttons.push({ type: 'default', label: 'Редагувати дані', event: 'edit-data' });
      return buttons;
    },
  },
  methods: {
    toString(value) {
      return typeof value === 'object' ? JSON.stringify(value) : String(value);
    },
    openSubmitError(responseMessage, errorInfo) {
      this.isConfirmMode = false;
      this.popupTitle = 'Увага! При спробі заявити/підписати полісу виникла помилка';
      this.responseMessage = this.toString(responseMessage);
      this.errorInfo = errorInfo || null;
      this.$refs.confirmationPopup.open();
    },

    openConfirmError(responseMessage) {
      this.isConfirmMode = true;
      this.popupTitle = 'Увага! При спробі оформлення полісу виникла помилка';
      this.responseMessage = this.toString(responseMessage);
      this.errorInfo = null;
      this.$refs.confirmationPopup.open();
    },

    close() {
      this.$refs.confirmationPopup?.close();
    },

    onClose() {
      this.responseMessage = null;
      this.errorInfo = null;
      this.$emit('closed');
    },

    onEditData() {
      this.$emit('edit-data');
      this.close();
    },

    onSearchOffers() {
      this.$emit('search-offers');
      this.close();
    },
  },
};
</script>